import styled from 'styled-components';

export const ContainerAcordion = styled.div`
  width: 93%;
  margin: auto;
  margin-bottom: 2rem;
`;

export const Space = styled.div`
  margin-top: 1rem;
`;

export const containerEmployee = {
  width: '100%',
  background: '#f6f7fc',
  height: 'auto',
  minHeight: '100vh',
};

export const searchContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '95%',
  margin: 'auto',
  marginBottom: '3rem',
  justifyContent: 'space-between',
};

export const findContainer = {
  display: 'flex',
  width: '60%',
  justifyContent: 'flex-end',
};

export default {
  containerEmployee,
  searchContainer,
  findContainer,
};
